if (!customElements.get('usp-drawer')) {
  class UspDrawer extends HTMLElement {
    constructor() {
      super();
      this.panels = this.querySelectorAll('[data-usp-panel]');
      this.titleEl = this.querySelector('.usp-drawer__title');
      this.buttonEl = this.querySelector('.usp-drawer__button');
      this.scrollEl = this.querySelector('.usp-drawer__scroll');
    }

    connectedCallback() {
      this.panels.forEach((panel) => {
        panel.classList.remove('usp-drawer__panel--active');
      });

      document.querySelectorAll('[data-usp-target]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open(btn.getAttribute('data-usp-target'));
        });
      });

      if (this.buttonEl) {
        this.buttonEl.addEventListener('click', () => {
          this.dispatchEvent(new CustomEvent('panel:close', { bubbles: true }));
        });
      }
    }

    open(index) {
      const panelId = String(index);

      this.panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-usp-panel') === panelId;
        panel.classList.toggle('usp-drawer__panel--active', isActive);
      });

      const activePanel = this.querySelector(`[data-usp-panel="${panelId}"]`);
      if (activePanel) {
        const title = activePanel.getAttribute('data-title');
        const buttonLabel = activePanel.getAttribute('data-button');
        if (this.titleEl) this.titleEl.textContent = title;
        if (this.buttonEl) this.buttonEl.textContent = buttonLabel;
      }

      if (this.scrollEl) {
        this.scrollEl.scrollTop = 0;
      }

      document.body.classList.add('open-cc');
      this.classList.add('active');
      this.focus();
    }
  }

  customElements.define('usp-drawer', UspDrawer);
}
